import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestDTO } from 'src/app/core/services/business/model/request-dto';
import { DetenteurComponent } from 'src/app/formulaire/modal/detenteur/detenteur.component';
import { SuiviComponent } from 'src/app/formulaire/modal/suivi/suivi.component';
import { LibererDossier } from 'src/app/parametrage/core/model/request/liberer-dossier';
import { RepartiteurService } from 'src/app/mon-portefeuille/core/service/repartiteur.service';
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { AbandonnerDossierComponent } from 'src/app/formulaire/modal/abandonner-dossier/abandonner-dossier.component';
import { ChangerInitiateurDossierComponent } from 'src/app/formulaire/modal/changer-initiateur-dossier/changer-initiateur-dossier.component';
import { AnnulerCorrection } from 'src/app/mon-portefeuille/core/model/annuler-correction';
import { CorrectionHistoryService } from 'src/app/mon-portefeuille/core/service/correction-history.service';
import { ReactiverDossierComponent } from 'src/app/formulaire/modal/reactiver-dossier/reactiver-dossier.component';
import { CorporateService } from '../../core/service/corporate.service';

@Component({
  selector: 'app-tous',
  templateUrl: './tous.component.html',
  styleUrls: ['./tous.component.scss']
})
export class TousComponent implements OnInit {

  isLoadingResults = true;

  dossiers: RequestDTO[];
  formulaire: FormulaireDTO;

  page: number = 0;
  totalElements: number = 0;
  filter: String = "";
  state: String = "";

  libererDossier: LibererDossier;
  annulerCorrection: AnnulerCorrection;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _corporateService: CorporateService,
    private _formulaireService: FormulaireService,
    private _repartiteurService : RepartiteurService,
    private _requestService: RequestService,
    private _correctionHistoryService: CorrectionHistoryService
  ) {}

  ngOnInit() {
    this.getAll(this.filter, this.state, null,null, 0, 5);
  }

  getAll(filter, state, debut, fin, page, size) {
    this.isLoadingResults = true;

    this._corporateService
      .findAllDossier(filter, state, debut, fin, page, size, "id","desc")
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElements = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAll(this.filter, this.state, null,null, page, 5);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAll(this.filter, this.state, null,null, this.page, 5);
  }

  filterByState(): void {
    this.getAll(this.filter, this.state, null,null, 0, 5);
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  userByRole(requestId) {
    const modalRef = this.modalService.open(DetenteurComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  liberer(requestId): void {
    this.libererDossier = new LibererDossier();
    this.libererDossier.requestId = requestId;
    this._requestService
      .liberer(this.libererDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  abandonner(requestId) {
    const modalRef = this.modalService.open(AbandonnerDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
      },
      (reason) => {}
    );
  }

  changerInitiateur(requestId) {
    const modalRef = this.modalService.open(ChangerInitiateurDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
      },
      (reason) => {}
    );
  }
  
  assigneTaskForCurrentRequest(requestId) {
    this._repartiteurService.assigneTaskForCurrentRequest(requestId).subscribe(
      (data) => {
        this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  annuler(correctionId): void {
    this.annulerCorrection = new AnnulerCorrection();
    this.annulerCorrection.correctionId = correctionId;
    this._correctionHistoryService
      .annuler(this.annulerCorrection)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
        },
        (error) => {
          console.log(error);
        }
      );
  }


  reactiver(requestId) {
    const modalRef = this.modalService.open(ReactiverDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
          this.getAll(this.filter, this.state, null,null, this.page - 1, 5);
      },
      (reason) => {}
    );
  }

}
